"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledDomainInput = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const config_1 = require("../../../assets/styles/config");
exports.StyledDomainInput = styled_components_1.default.input `
  background: transparent;
  border: 0;
  font: ${config_1.fontSizes.base} ${config_1.fontFamilies.primary};
  outline: none;
  padding: 0;
  text-align: end;
  width: 60%;
`;
